<template>
  <div class="modal-aside-component">
    <DefDarkenBackground @close="hide" />
    <DefSlideRight appear @afterLeave="afterLeave">
      <div v-if="isOpen.value" class="modal-aside-content">
        <slot />
      </div>
    </DefSlideRight>
  </div>
</template>

<script lang="ts" setup>
import { Ref, onUnmounted, nextTick } from 'vue';
import useModalAside from '@use/useModalAside/useModalAside';
import DefSlideRight from '@components/Def/DefAnimations/DefSlideRight.vue';
import DefDarkenBackground from '@components/Def/DefDarkenBackground/DefDarkenBackground.vue';

const modalAside = useModalAside();

const props = defineProps<{
  isOpen: Ref;
  options?: {
    width?: string;
    backgroundClose?: boolean;
    empty?: boolean;
    padding?: boolean;
  };
  afterLeave: () => void;
  afterRemove: () => void;
}>();

const hide = () => {
  modalAside.hide();
};
onUnmounted(async () => {
  if (typeof props?.afterRemove === 'function') {
    await nextTick();
    props.afterRemove();
  }
});
</script>

<style lang="scss" scoped>
.modal-aside-component {
}
.modal-aside-content {
  position: fixed;
  z-index: 10003;
  top: 0;
  right: 0;

  display: flex;
  flex-direction: column;

  background-color: #fff;
  width: 100%;
  // цей дубиль потрібний для підтримки старими браузерами
  height: 100vh;
  height: 100dvh;
  @include point-md {
    width: 640px;
  }
  @include point-lg {
    width: 840px;
  }
  :deep(> *) {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }
}
</style>
